import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

// Hooks
import { useCaptureVictimButton } from "../CaptureVictimButton/CaptureVictimButton";
import { useShareWith } from "../../containers/ShareWithPage/ShareWithProvider";
import useDialog from "../../hooks/useDialog";

// Components
import ConfirmationButton from "../ConfirmationButton";

export const useSubmitButton = recipient => {
  const { updateRecipient } = useShareWith();
  const { caseId } = useParams();

  const { fileUploadProps } = useCaptureVictimButton(caseId);
  const { data } = useSelector(s => s.caseDetail);
  const getDialogProps = useDialog();

  const functions = {
    provideDetails: () => updateRecipient(recipient)
  };

  const modalProps = data && getDialogProps(data, functions);

  return { ...modalProps, fileUploadProps };
};

const SubmitCaseButton = ({
  buttonProps,
  children,
  className,
  disabled,
  recipient
}) => {
  const { dialog, onConfirm } = useSubmitButton(recipient);

  return (
    <>
      <ConfirmationButton
        className={className}
        dialog={dialog}
        disabled={disabled}
        onClick={onConfirm}
        variant="outlined"
        type="card"
        {...buttonProps}
      >
        {children}
      </ConfirmationButton>
    </>
  );
};

SubmitCaseButton.propTypes = {
  buttonProps: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  recipient: PropTypes.shape({}).isRequired
};

SubmitCaseButton.defaultProps = {
  buttonProps: null,
  className: null,
  disabled: false
};

export default SubmitCaseButton;
